import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import WebsiteButton from "@/components/website-button/WebsiteButton"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { scrollToSection } from "@/helpers/scrollToSection"
import { WAYLEAVE_GUIDE_PATH, websiteRoutes } from "@/router/routes"
import { EASETECH } from "@/utilities/global-variables"
import { Space } from "antd"
import { FC } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"

const { Paragraph, Text } = WebsiteTypography

import "./FooterContentBlock.less"

const FooterContentBlock: FC = () => {
  const navigate = useNavigate()
  const { website } = websiteRoutes
  const params = useParams()
  // The footer also renders on `/`, which has no :org param — fall back so links never become `/undefined/...`.
  const currentOrgSlug = params.org ?? EASETECH

  const { openDarkModal } = useModalDarkContext()

  const onSoftwareSolutionsClick = async () => {
    navigate(`/easetech${website.software}`)
    await scrollToSection("software-solutions")
  }

  const onConsultingServicesClick = async () => {
    navigate(`/easetech${website.consulting}`)
    await scrollToSection("our-consulting-services")
  }

  const onHomeClick = async () => {
    navigate(`/easetech${website.home}`)
  }

  const handleContactRequestClick = () => {
    openDarkModal({
      type: "quick-contact",
      isLogo: true,
    })
  }

  return (
    <>
      <div className={"content-block"}>
        <div className={"navigation"}>
          <div className={"footer-content-title"}>
            <Text weight={"w700"} size={"lg"}>
              {"Navigation"}
            </Text>
          </div>
          <WebsiteButton btnType={"text"} onClick={onHomeClick}>
            <Text weight={"w700"} color={"website-secondary"} size={"md"}>
              {"Home"}
            </Text>
          </WebsiteButton>
          {/* A static page outside this app: a real link (href), so it is a full page load and search engines follow it. */}
          <WebsiteButton btnType={"text"} href={WAYLEAVE_GUIDE_PATH}>
            <Text weight={"w700"} color={"website-secondary"} size={"md"}>
              {"Wayleave guide"}
            </Text>
          </WebsiteButton>
          <WebsiteButton btnType={"text"} onClick={handleContactRequestClick}>
            <Text weight={"w700"} color={"website-secondary"} size={"md"}>
              {"Quick contact"}
            </Text>
          </WebsiteButton>

          <Space direction={"vertical"} size={"small"} className={"auth-btns-footer"}>
            <WebsiteButton btnType={"ghost-white"} block>
              <Link to={`/${currentOrgSlug}${website.auth}/wayleave/login`}>
                <Text>{"SIGN IN"}</Text>
              </Link>
            </WebsiteButton>
            <WebsiteButton btnType={"primary"} block>
              <Link to={`/${currentOrgSlug}${website.auth}/wayleave/client`}>
                <Text>{"REGISTER"}</Text>
              </Link>
            </WebsiteButton>
          </Space>
        </div>
      </div>
      <div className={"content-block links-block"}>
        <div className={"footer-content-title"}>
          <Text weight={"w700"} size={"lg"}>
            {"Our Services"}
          </Text>
        </div>
        <WebsiteButton btnType={"text"} onClick={onSoftwareSolutionsClick}>
          <Text weight={"w700"} color={"website-secondary"} size={"md"}>
            {"Software Solution"}
          </Text>
        </WebsiteButton>
        <WebsiteButton btnType={"text"} onClick={onConsultingServicesClick}>
          <Text weight={"w700"} color={"website-secondary"} size={"md"}>
            {"Consulting Services"}
          </Text>
        </WebsiteButton>
      </div>
      <div className={"content-block"}>
        <div className={"footer-content-title"}>
          <Text weight={"w700"} size={"lg"}>
            {"Contact us"}
          </Text>
        </div>
        <div className={"contact-us-item"}>
          <Text
            size={"sm"}
            lh={"lh-lg"}
            color={"website-secondary"}
            className={"number-text-title"}
            id={"phone-section"}
          >
            {"Phone:"}
          </Text>

          <a href={"tel:+0826996888"} className={"contact-phone-item"}>
            <SvgIcon type={"whatsapp"} color={"white"} />
            <Paragraph weight={"w700"} size={"lg"} className={"number-text"} centered style={{ letterSpacing: "2px" }}>
              {"082 699 6888"}
            </Paragraph>
          </a>

          <a href={"tel:+0107454941"} className={"contact-phone-item"}>
            <SvgIcon type={"phone"} color={"white"} />
            <Paragraph weight={"w700"} size={"lg"} className={"number-text"} centered style={{ letterSpacing: "2px" }}>
              {"010 745 4941"}
            </Paragraph>
          </a>
        </div>

        <div className={"contact-us-item email-section"} style={{ paddingTop: "12px" }}>
          <Text size={"sm"} color={"website-secondary"}>
            {"Email:"}
          </Text>
          <a href={"mailto:info@easetech.co.za"}>
            <Text weight={"w300"} size={"md"} color={"orange"}>
              {"info@easetech.co.za"}
            </Text>
          </a>
        </div>
      </div>
    </>
  )
}

export default FooterContentBlock
